import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
    name:"profile",
    initialState:{
        profile: null,
        usersCount: null,
        profiles:[],
        isProfileDeleted: false,
       
    }, 

    reducers:{
      setProfile(state, action){
        state.profile = action.payload
      },
      setUserCount(state,action){
        state.usersCount = action.payload
      },
      setProfiles(state,action){
        state.profiles = action.payload
      },
      setisProfileDeleted(state){
        state.isProfileDeleted = true;
      },
      resetProfileDeleted(state) {
        state.isProfileDeleted = false;
      },
      updateProfile(state, action){
        state.profile = action.payload
      },
      updateUserInProfiles(state, action) {
        state.profiles = state.profiles.map(user =>
          user._id === action.payload._id ? action.payload : user
        );
      }


    }
});


const profileReducer = profileSlice.reducer;
const profileActions = profileSlice.actions;

export {profileActions , profileReducer}